enum langEnum {
	fr= 'fr',
	en = 'en'
}
export default langEnum